import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CentreDetailsDocument } from '../../graphql';
import { assertPropsNotNull, setDefaultProps } from './utils';
const requiredProps = ['title', 'status', 'slug', 'physicalAddress', 'suburb', 'postcode', 'state', 'country', 'latitude', 'longitude', 'timeZone', 'telephoneNumber', 'emailAddress', 'facebook', 'instagram', 'navigationMenu', 'centreFrontImage'];
export async function getCentreDetails(client, _ref) {
  var _data$cfCentreCollect;
  let {
    slug,
    country
  } = _ref;
  const {
    data
  } = await client.query({
    query: CentreDetailsDocument,
    context: {
      version: 2
    },
    variables: {
      slug,
      country
    }
  });
  const result = data === null || data === void 0 || (_data$cfCentreCollect = data.cfCentreCollection) === null || _data$cfCentreCollect === void 0 || (_data$cfCentreCollect = _data$cfCentreCollect.items) === null || _data$cfCentreCollect === void 0 || (_data$cfCentreCollect = _data$cfCentreCollect.filter(item => {
    var _item$slug;
    return (item === null || item === void 0 || (_item$slug = item.slug) === null || _item$slug === void 0 ? void 0 : _item$slug.toLowerCase()) === slug.toLowerCase();
  })) === null || _data$cfCentreCollect === void 0 ? void 0 : _data$cfCentreCollect[0];
  if (!result) {
    return null;
  }
  const centre = setDefaultProps(result, {
    timeZone: 'UTC'
  });
  assertPropsNotNull(centre, requiredProps, () => {
    throw new Error('Centre object missing required properties');
  });
  const filteredFeatures = centre.features ? centre.features.filter(feature => Boolean(feature)) : null;
  return _objectSpread(_objectSpread({}, centre), {}, {
    features: filteredFeatures
  });
}
export const buildContactLinks = centre => [{
  type: 'facebook',
  url: centre.facebook
}, {
  type: 'instagram',
  url: centre.instagram
}].filter(link => link.url !== null);